export const ignoreClick = (event) => {
  event.preventDefault()
  event.stopPropagation()
}